/* @ngInject */
const myEmailsCreate = (
  toaster,
  valueHandler,
  $$email
) => {
  return {
    restrict: 'E',
    scope: {
      myEmails: '=',
      id: '@myId',
    },
    template: require('./myEmailsCreate.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$email.metadata.fields

      $scope.addEmail = () => {
        $scope.myEmails.push($$email.new())
      }

      $scope.removeEmail = async (_index) => {
        const id = $scope.myEmails[_index].id
        if (valueHandler.isId(id)) {
          try {
            await $$email.request.delete(id)
            $scope.myEmails.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.myEmails.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myEmailsCreate



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/directives/myEmailsCreate.js